export const si = {
  // Navigation
  home: "මුල් පිටුව",
  about: "අප ගැන",
  tours: "සංචාර",
  deals: "ගනුදෙනු",
  testimonials: "පාර්ශවකරුවන්",
  blog: "බ්ලොග්",
  contact: "සම්බන්ධ වන්න",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "ශ්‍රී ලංකාවට සාදරයෙන් පිළිගනිමු",
  welcomeSubtitle: "ඉන්දියන් සාගරයේ මුතුව ලෙස හඳුන්වන රටේ සුන්දරත්වය සොයා බලන්න",
  exploreButton: "සංචාර ගවේෂණය කරන්න",
  learnMoreButton: "තවත් දැනගන්න",
  
  // About page
  aboutTitle: "අප ගැන",
  aboutSubtitle: "ශ්‍රී ලංකාවේ ඔබගේ විශ්වසනීය සංචාර හවුල්කාරයා",
  aboutDescription: "අපි පිරිසිදු වෙරළවල් සිට පුරාණ දේවස්ථාන දක්වා ශ්‍රී ලංකාව පුරා අමතක නොවන සංචාර අත්දැකීම් නිර්මාණය කිරීමේ විශේෂඥයින් වෙමු.",
  
  // Tours page
  toursTitle: "අපගේ සංචාර",
  toursSubtitle: "අපූරු ගමනාන්ත සොයා බලන්න",
  bookNow: "දැන් වෙන් කරන්න",
  viewDetails: "විස්තර බලන්න",
  
  // Contact page
  contactTitle: "අප හා සම්බන්ධ වන්න",
  contactSubtitle: "අප හා සම්බන්ධ වීමට",
  name: "නම",
  email: "විද්‍යුත් තැපෑල",
  message: "පණිවිඩය",
  send: "පණිවිඩය යවන්න",
  phone: "දුරකථන",
  address: "ලිපිනය",
  
  // Testimonials
  testimonialsTitle: "අපගේ පාරිභෝගිකයින් කියන්නේ කුමක්ද",
  testimonialsSubtitle: "සැබෑ සංචාරකයින්ගෙන් සැබෑ අත්දැකීම්",
  
  // Blog
  blogTitle: "සංචාර බ්ලොග්",
  blogSubtitle: "නවතම සංචාර කතන්දර සහ උපදෙස්",
  readMore: "තවත් කියවන්න",
  
  // Common
  loading: "පූරණය වෙමින්...",
  error: "දෝෂයක් සිදු විය",
  success: "සාර්ථකයි!",
  close: "වසන්න",
  submit: "යොමු කරන්න",
  cancel: "අවලංගු කරන්න",
  
  // Language selector
  selectLanguage: "භාෂාව තෝරන්න",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  
  // About Us Page
  whyChooseTitle: "ඇයි ශ්‍රී යාත්‍රා සංචාර තෝරන්නේ?",
  whyChooseSubtitle: "අපි ඔබට හොඳම සංචාර අත්දැකීම් සහ විශේෂ සේවාවක් සහ පුද්ගලික පැකේජ සමඟ සැපයීමට කැපවී සිටිමු.",
  personalizedTitle: "පුද්ගලික සංචාර සැලසුම්කරණය",
  personalizedDesc: "අපි ඔබගේ අද්විතීය අවශ්‍යතා සපුරාලීම සඳහා සෑම ගමනක්ම අභිරුචිකරණය කරමු, එක්-එක් සංචාර අත්දැකීමක් සහතික කරමු.",
  customerSupportTitle: "24/7 පාරිභෝගික සහාය",
  customerSupportDesc: "අපගේ කැපවූ සංචාර විශේෂඥයින් ඔබගේ ඕනෑම ප්‍රශ්නයකට උපකාර කිරීමට දින-රාත්‍රිය පුරාම ලබා ගත හැකිය.",
  destinationsTitle: "තෝරාගත් ගමනාන්ත",
  destinationsDesc: "ඔබට අමතක නොවන අත්දැකීම් ලබා දීමට හොඳින් තෝරාගත් හොඳම ගමනාන්ත ගවේෂණය කරන්න.",
  priceGuaranteeTitle: "හොඳම මිල සහතිකය",
  priceGuaranteeDesc: "අපි ඔබගේ සංචාර අත්දැකීමේ ගුණාත්මකභාවය අඩු නොකර තරඟකාරී මිලක් ලබා දෙමු.",
  luxuryTitle: "විලාසිතා සහ සුවපහසුව",
  luxuryDesc: "උත්තම සුවපහසුව සඳහා විලාසිතා නවාතැන් සහ අඛණ්ඩ සංචාර සැකසුම් භුක්ති විඳින්න.",
  guidesTitle: "විශේෂඥ සංචාර මඟපෙන්වන්නන්",
  guidesDesc: "අපගේ දැනුමෙන් යුත් සහ මිත්‍රශීලී මඟපෙන්වන්නන් ඔබගේ ගමනෙන් උපරිම ප්‍රයෝජන ගැනීම සහතික කරයි.",
  
  // Contact Page
  getInTouchTitle: "ශ්‍රී යාත්‍රා සංචාර සමඟ සම්බන්ධ වන්න",
  loveToHearTitle: "ඔබගෙන් අපට ඇසීමට අවශ්‍යයි",
  loveToHearDesc: "ඔබට අපගේ සංචාර, මිල නියම කිරීම, හෝ වෙනත් ඕනෑම දෙයක් ගැන ප්‍රශ්නයක් තිබේ නම්, අපගේ කණ්ඩායම ඔබගේ සියලුම ප්‍රශ්නවලට පිළිතුරු දීමට සූදානම්ය.",
  office: "කාර්යාලය",
  phone: "දුරකථන",
  support: "සහාය",
  email: "විද්‍යුත් තැපෑල",
  officeAddress: "වටබාගේ හන්දිය, පානදුර, ශ්‍රී ලංකාව",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "අපට පණිවිඩයක් යවන්න",
  contactFormDesc: "පහත පෝරමය පුරවා අපි හැකි ඉක්මනින් ඔබට පිළිතුරු දෙන්නමු.",
  namePlaceholder: "ඔබගේ නම",
  emailPlaceholder: "ඔබගේ විද්‍යුත් තැපෑල",
  phonePlaceholder: "ඔබගේ දුරකථන අංකය",
  messagePlaceholder: "ඔබගේ පණිවිඩය",
  submitButton: "පණිවිඩය යවන්න",
  submitting: "යවමින්...",
  messageSent: "පණිවිඩය සාර්ථකව යවන ලදී!",
  messageError: "පණිවිඩය යැවීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  
  // Testimonials Page
  customerReviewsTitle: "අපගේ පාරිභෝගිකයින් කියන්නේ කුමක්ද",
  customerReviewsSubtitle: "අප සමඟ ශ්‍රී ලංකාව ගවේෂණය කළ සැබෑ සංචාරකයින්ගෙන් සැබෑ අත්දැකීම්",
  
  // Blog Page
  travelBlogTitle: "සංචාර බ්ලොග්",
  travelBlogSubtitle: "ශ්‍රී ලංකාවේ අපගේ වික්‍රමාන්තවලින් නවතම සංචාර කතන්දර, උපදෙස් සහ අවබෝධයන්",
  
  // Tours Page
  ourToursTitle: "අපගේ සංචාර",
  ourToursSubtitle: "අපූරු ගමනාන්ත සහ අමතක නොවන අත්දැකීම් සොයා බලන්න",
  
  // Deals Page
  specialDealsTitle: "විශේෂ ගනුදෙනු",
  specialDealsSubtitle: "අපගේ හොඳම සංචාරවල විශේෂ ඉල්ලීම් සහ වට්ටම්",
  
  // Tour Content
  culturalTourTitle: "ශ්‍රී ලංකා සංස්කෘතික සංචාරය",
  culturalTourDesc: "මෙම සංස්කෘතික සංචාරයේදී ශ්‍රී ලංකාවේ සමෘද්ධ උරුමය සහ ඓතිහාසික ස්ථාන අත්දැකීම් කරන්න.",
  wildlifeTourTitle: "වනජීවී සෆාරි වික්‍රමාන්තය",
  wildlifeTourDesc: "ශ්‍රී ලංකාවේ ප්‍රසිද්ධ වනජීවී උද්‍යාන සහ විශේෂ සතුන් ඔවුන්ගේ ස්වභාවික වාසස්ථානවල නිරීක්ෂණය කරන්න.",
  beachTourTitle: "වෙරළ නිවාඩුව",
  beachTourDesc: "ශ්‍රී ලංකාවේ අතිශයින්ම සුන්දර වෙරළවල්වල ස්ඵටික පැහැදිලි ජල සහ රන්වන් වැලි සමඟ සන්සුන් වන්න.",
  hillCountryTourTitle: "උඩරට වික්‍රමාන්තය",
  hillCountryTourDesc: "ශ්‍රී ලංකාවේ කඳු, ජලධරා සහ තේ වතු සුන්දරත්වය සොයා බලන්න.",
  honeymoonTourTitle: "විලාසිතා හිමිදිරි සංචාර පැකේජය",
  honeymoonTourDesc: "ශ්‍රී ලංකාවේ හොඳම ගස්ට්හවුස්වල රෝමාන්ටික සහ විලාසිතා හිමිදිරි අත්දැකීමක් භුක්ති විඳින්න.",
  adventureTourTitle: "වික්‍රමාන්ත සහ පා ගමන සංචාරය",
  adventureTourDesc: "ශ්‍රී ලංකාවේ රෞද්‍ර වික්‍රමාන්ත පා ගමන් සහ බාහිර ක්‍රියාකාරකම්වල නිරත වන්න.",
  
  // Deal Content
  exclusiveHoneymoonTitle: "විශේෂ ශ්‍රී ලංකා හිමිදිරි සංචාර පැකේජය",
  exclusiveHoneymoonDesc: "රෝමාන්ටික නිවාඩු, වෙරළ ගස්ට්හවුස් සහ සංස්කෘතික අත්දැකීම් සමඟ විලාසිතා හිමිදිරි නිවාඩුවක් භුක්ති විඳින්න.",
  adventureWildlifeTitle: "වික්‍රමාන්ත සහ වනජීවී සංචාරය",
  adventureWildlifeDesc: "රෞද්‍ර සෆාරි සහ ස්වභාවික ගවේෂණ සමඟ ශ්‍රී ලංකාවේ වනාන්තර ගවේෂණය කරන්න.",
  luxuryBeachTitle: "විලාසිතා වෙරළ නිවාඩුව",
  luxuryBeachDesc: "හොඳම වෙරළවල්වල සන්සුන් වන්න, ජල ක්‍රීඩා භුක්ති විඳින්න සහ උසස්තම සත්කාරය අත්දැකීම් කරන්න.",
  culturalHeritageTitle: "සංස්කෘතික උරුම සංචාරය",
  culturalHeritageDesc: "ශ්‍රී ලංකාවේ යුනෙස්කෝ උරුම ස්ථාන, පුරාණ දේවස්ථාන සහ ජීවනෝපේත නගර සංචාරය කරන්න.",
  budgetFamilyTitle: "අඩු මිල පවුල් නිවාඩුව",
  budgetFamilyDesc: "සියලු වයස්වලට රෞද්‍ර ක්‍රියාකාරකම් සහිත ලාභදායී පවුල්-හිතකාමී පැකේජයක්.",
  ultimateAdventureTitle: "උත්තම වික්‍රමාන්ත සංචාරය",
  ultimateAdventureDesc: "ශ්‍රී ලංකාවේ අපූරු භූමි රූපවල පා ගමන්, රැෆ්ටිං සහ වික්‍රමාන්ත ක්‍රීඩා.",
  
  // Blog Content
  exploringBeautyTitle: "ශ්‍රී ලංකාවේ සුන්දරත්වය ගවේෂණය කිරීම",
  exploringBeautyExcerpt: "මෙම සවිස්තරාත්මක සංචාර මාර්ගෝපදේශයේ ශ්‍රී ලංකාවේ අපූරු භූමි රූප, සමෘද්ධ ඉතිහාසය සහ සංස්කෘතික ආශ්චර්‍ය සොයා බලන්න.",
  bestBeachesTitle: "ශ්‍රී ලංකාවේ හොඳම වෙරළවල්",
  bestBeachesExcerpt: "රන්වන් වැලි වෙරළවල් සිට අපූරු ටර්කොයිස් ජල දක්වා, පරිපූර්ණ නිවාඩුවක් සඳහා ශ්‍රී ලංකාවේ හොඳම වෙරළ ගමනාන්ත ගවේෂණය කරන්න.",
  wildlifeSafariTitle: "වනජීවී සෆාරි වික්‍රමාන්ත",
  wildlifeSafariExcerpt: "ශ්‍රී ලංකාවේ ප්‍රසිද්ධ ජාතික උද්‍යානවල ඇතුන්, කොටි සහ විශේෂ පක්ෂීන් දැකීමේ රෞද්‍රත්වය අත්දැකීම් කරන්න.",
  
  // Testimonial Content
  johnReview: "ශ්‍රී ලංකාවට අපගේ ගමන සම්පූර්ණයෙන්ම අපූර්වයි! සැලසුම්කරණය සහ සංවිධානය පරිපූර්ණ විය, සහ ගමන පුරාම අපට හොඳින් රැකබලා ගන්නා ලදී. ශ්‍රී යාත්‍රා සංචාර බෙහෙවින් නිර්දේශ කරමි!",
  emmaReview: "සැබෑවෙන්ම මතක තබා ගත හැකි අත්දැකීමක්! සුන්දර වෙරළවල් සිට අපූරු සංස්කෘතික ස්ථාන දක්වා, සෑම දෙයක්ම පරිපූර්ණව සැලසුම් කර තිබුණි. නැවත ගොස් බලීමට බලාපොරොත්තු වෙමි!",
  carlosReview: "මම කවදාවත් වෙන් කර ඇති හොඳම සංචාර ඒජන්සිය! සෑම දෙයක්ම හොඳින් සංවිධානය කර තිබුණි, සහ මඟපෙන්වන්නන් දැනුමෙන් යුත් සහ මිත්‍රශීලී විය. අපූරු අත්දැකීමක් සඳහා ස්තූතියි!",
  sophiaReview: "අඛණ්ඩ සහ අමතක නොවන ගමනක්! කණ්ඩායම වෘත්තීය විය, සහ සංචාර සැලසුම හොඳින් සිතා බලා තිබුණි. ශ්‍රී ලංකාවට පැමිණෙන ඕනෑම කෙනෙකුට ශ්‍රී යාත්‍රා සංචාර බෙහෙවින් නිර්දේශ කරමි.",
  
  // Common Labels
  activities: "ක්‍රියාකාරකම්",
  duration: "කාලසීමාව",
  price: "මිල",
  workingHours: "වැඩ කරන පැය",
  workingHoursText: "සඳුදා – සිකුරාදා: උදේ 9:00 – සවස 6:00",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "ශ්‍රී ලංකාවේ ආකර්ෂණ",
  fiveDayHighlightsSubtitle: "ආකර්ෂණ: කටුනායක, සීගිරිය, මහනුවර, ඇල්ල, ගාල්ල. ශ්‍රී ලංකාවේ බැලිය යුතු ගමනාන්ත හරහා සංක්ෂිප්ත ගමනක්.",
  bookNow: "දැන් වෙන් කරන්න",
  
  // Katunayake
  day1Title: "පැමිණීම",
  katunayakeTitle: "කටුනායක",
  katunayakeStay: "කටුනායක අසල සුවපහසු නවාතැන",
  katunayakeActivities: "ක්‍රියාකාරකම්",
  katunayakeArrival: "බණ්ඩාරනායක ජාත්‍යන්තර ගුවන්තොටුපළට පැමිණීම",
  katunayakeMeetGreet: "හමුවීම සහ පිළිගැනීම, අසල නවාතැනට මාරුවීම",
  katunayakeNegombo: "නෙගොම්බෝ වෙරළට විකල්ප සංචාරය (කාලය ඉඩ දෙන්නේ නම්)",
  katunayakeRest: "ගුවන් ගමනෙන් සන්සුන් වීම",
  katunayakeLocation: "කටුනායක - බණ්ඩාරනායක ජාත්‍යන්තර ගුවන්තොටුපළ",
  katunayakeDescription: "ගුවන්තොටුපළ අසල පහසු පළමු රාත්‍රියක් සමඟ ඔබගේ ශ්‍රී ලාංකික ආකර්ෂණ ආරම්භ කරන්න.",
  
  // Sigiriya
  day2Title: "සීගිරිය",
  sigiriyaTitle: "සීගිරිය",
  sigiriyaStay: "සීගිරියේ ගස්ට්හවුස්",
  sigiriyaTransfer: "සීගිරියට මාරුවීම",
  sigiriyaClimb: "සීගිරිය ගල් බලකොටුවට නැගීම",
  sigiriyaExplore: "ජල උද්‍යාන සහ චිත්‍ර ගවේෂණය කිරීම",
  sigiriyaVillage: "ගම්මාන අත්දැකීම හෝ බයිසිකල් ගමන (විකල්ප)",
  sigiriyaLocation: "සීගිරිය ගල් බලකොටුව",
  sigiriyaDescription: "විසිතරාකාර දර්ශන සහිත අයිකොනික් යුනෙස්කෝ ලෝක උරුම අඩවිය.",
  
  // Kandy
  day3Title: "මහනුවර",
  kandyTitle: "මහනුවර",
  kandyStay: "මහනුවරේ හෝටලය",
  kandyTransfer: "මහනුවරට මාරුවීම",
  kandyTemple: "ශ්‍රී දළදා මාළිගාව",
  kandyGardens: "රාජකීය උද්‍යාන, පේරාදෙණිය",
  kandyLake: "මහනුවර වැව ඇවිදීම සහ දේශීය වෙළඳපොළ",
  kandyLocation: "ශ්‍රී දළදා මාළිගාව, මහනුවර",
  kandyDescription: "පූජනීය උරුමය සහ සිරිත් උද්‍යාන සහිත සංස්කෘතික අගනුවර.",
  
  // Ella
  day4Title: "ඇල්ල",
  ellaTitle: "ඇල්ල",
  ellaStay: "ඇල්ලේ සුවපහසු නවාතැන",
  ellaTrain: "ඇල්ලට සුන්දර දුම්රිය ගමන",
  ellaPeak: "කුඩා ආදම් කන්ද ගවේෂණය",
  ellaBridge: "නව ආර්ච් බොඩිය දර්ශන ලක්ෂ්‍යය",
  ellaExplore: "නගරයේ තේ රටේ ආවේග ගවේෂණය කිරීම",
  ellaLocation: "ඇල්ල අසල සුන්දර දුම්රිය",
  ellaDescription: "අපූරු කඳු දර්ශන සහිත සිසිල් කාලගුණයේ කඳු ගැලවීම.",
  
  // Galle
  day5Title: "ගාල්ල",
  galleTitle: "ගාල්ල",
  galleStay: "ගාල්ලේ හෝටලය (හෝ පසු පිටත්වීම)",
  galleTransfer: "ගාල්ලට මාරුවීම",
  galleFort: "යුනෙස්කෝ ලැයිස්තුගත ගාල්ල බලකොටුව ගවේෂණය කිරීම",
  galleLighthouse: "ප්‍රදීපාගාරය සහ බලකොටු බිත්ති ඇවිදීම",
  galleCafes: "කැෆේ, බූටික් සහ මුහුදු ඉවුරු දර්ශන",
  galleContinue: "ගුවන්තොටුපළට යාම හෝ වෙරළ නවාතැන දීර්ඝ කිරීම",
  galleLocation: "ගාල්ල බලකොටු බිත්ති සහ ප්‍රදීපාගාරය",
  galleDescription: "ඔබගේ ආකර්ෂණ අවසන් කිරීමට ඓතිහාසික වෙරළ ආකර්ෂණය",
  
  // Colombo Tour
  threeDayColomboTitle: "කොළඹ සංචාරය - ශ්‍රී ලංකාව",
  threeDayColomboSubtitle: "විලාසිතා හෝටල්, සංස්කෘතික සංචාර, සාප්පු ගැනීම සහ මුහුදු ඉවුරේ සන්සුන් වීම සමඟ කොළඹේ හොඳම අත්දැකීම් ලබා ගන්න.",
  
  // Colombo
  dayOneTitle: "පැමිණීම",
  dayTwoTitle: "නගර සංචාරය", 
  dayThreeTitle: "පිටත්වීම",
  
  // Day One Activities
  colomboArrival: "බණ්ඩාරනායක ජාත්‍යන්තර ගුවන්තොටුපළට පැමිණීම",
  colomboTransfer: "හෝටලයට මාරුවීම සහ ලියාපදිංචිය",
  colomboFort: "කොළඹ බලකොටු ප්‍රදේශය ගවේෂණය කිරීම – යටත්විජිත ගොඩනැගිලි, වෙළඳපොළ සහ සාප්පු ගැනීම",
  colomboDinner: "හෝටල අවන්හලේ රාත්‍රි භෝජනය සහ රාත්‍රියේ නවාතැන.",
  
  // Day Two Activities
  colomboBreakfast: "හෝටලයේ උදෑසන ආහාරය",
  colomboTemple: "ගංගාරාමය දේවස්ථානය සහ කෞතුකාගාරය සංචාරය",
  colomboLunch: "දේශීය අවන්හලේ දිවා ආහාරය",
  colomboMuseum: "ජාතික කෞතුකාගාරය සහ විහාරමහාදේවී උද්‍යානයට සවස් සංචාරය",
  colomboOvernight: "රාත්‍රි භෝජනය සහ රාත්‍රියේ නවාතැන.",
  
  // Day Three Activities
  colomboRelax: "ගාල් ෆේස් ග්‍රීන්හි සන්සුන් වීම සහ මුහුද නැරඹීම",
  colomboShopping: "ඔඩෙල් හෝ බෙයාෆුට් ගැලරියේ සාප්පු ගැනීම",
  colomboPrepare: "පිටත්වීම සඳහා සූදානම් වීම",
  colomboCheckout: "ලියාපදිංචිය ඉවත් කිරීම සහ ගුවන්තොටුපළට මාරුවීම.",
  
  // Hotels
  cinnamonGrand: "සිනමන් ග්‍රෑන්ඩ් කොළඹ",
  shangriLa: "ෂංග්‍රි-ලා කොළඹ",
  kingsbury: "ද කිංස්බරි කොළඹ",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "අඩු මිල පැකේජය (ශ්‍රී ලංකාවේ ආකර්ෂණ)",
  fiveDayBudgetPackSubtitle: "ආකර්ෂණ",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "අඩු මිල",
  fiveDayBudgetPackHighlights: "ආකර්ෂණ",
  fiveDayBudgetPackCulture: "සංස්කෘතිය",
  fiveDayBudgetPackHistory: "ඉතිහාසය",
  fiveDayBudgetPackNature: "ස්වභාවය",
  fiveDayBudgetPackPrice: "පුද්ගලයෙකුට US $650 සිට",
  moreInformation: "තවත් තොරතුරු ➜",
  
  threeDayColomboCityTitle: "කොළඹ නගර අත්දැකීම",
  threeDayColomboCitySubtitle: "නගර සංචාරය",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "නගර සංචාරය",
  threeDayColomboCityCulture: "සංස්කෘතිය",
  threeDayColomboCityShopping: "සාප්පු ගැනීම",
  threeDayColomboCityLuxury: "විලාසිතා හෝටල්",
  threeDayColomboCitySightseeing: "සංචාර",
  threeDayColomboCityPrice: "පුද්ගලයෙකුට US $350 සිට",
  
  familyTripTitle: "ශ්‍රී ලංකාවට පවුල් සංචාරය",
  familyTripSubtitle: "පවුල් පැකේජය",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "වනජීවී",
  familyTripNature: "ස්වභාවය",
  familyTripCulture: "සංස්කෘතිය",
  familyTripHistory: "ඉතිහාසය",
  familyTripPrice: "පුද්ගලයෙකුට US $850 සිට",
  
  bestOfSriLankaTitle: "ශ්‍රී ලංකාවේ හොඳම",
  bestOfSriLankaSubtitle: "සවිස්තරාත්මක",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "වෙරළ",
  bestOfSriLankaWildlife: "වනජීවී",
  bestOfSriLankaNature: "ස්වභාවය",
  bestOfSriLankaCulture: "සංස්කෘතිය",
  bestOfSriLankaPrice: "පුද්ගලයෙකුට US $1250 සිට",
  
  romanticGetawayTitle: "ශ්‍රී ලංකාවේ රෝමාන්ටික නිවාඩුව",
  romanticGetawaySubtitle: "රෝමාන්ටික පැකේජය",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "ස්වභාවය",
  romanticGetawayBeach: "වෙරළ",
  romanticGetawayWildlife: "වනජීවී",
  romanticGetawayHistory: "ඉතිහාසය",
  romanticGetawayPrice: "පුද්ගලයෙකුට US $1700 සිට",
  
  // Why Choose Us
  whyChooseUsTitle: "ඇයි අපව තෝරන්නේ?",
  whyChooseUsSubtitle: "බොහෝ දෙනෙක් අපව ඔවුන්ගේ අංක 1 සංචාර ගමනාන්ත කළමනාකරණ සමාගම ලෙස තෝරාගෙන ඇත, සහ ඔබත් පහත හේතු නිසා අපව තෝරා ගනු ඇත.",
  
  whyChooseUsReason1: "අපි ශ්‍රී ලංකාවේ ඉහළම ගමනාන්ත කළමනාකරණ සමාගම් අතරින් එකක් වෙමු.",
  whyChooseUsReason2: "අපි ශ්‍රී ලංකාවේ ප්‍රමුඛ සංචාර මෙහෙයුම්කරුවන් අතරින් එක් අයෙක් වෙමු.",
  whyChooseUsReason3: "අපි සංචාරකයින් සහ සංචාර නියෝජිතයින්ට සම්පූර්ණ සංචාර පැකේජයක් ලබා දෙමු.",
  whyChooseUsReason4: "අපට ශ්‍රී ලංකා සංචාරක කර්මාන්තය පිළිබඳ විශාල දැනුමක් ඇති 40 දෙනෙකුගෙන් යුත් උද්‍යෝගී සහ වෘත්තීය කණ්ඩායමක් ඇත.",
  whyChooseUsReason5: "අපි ශ්‍රී ලංකාවේ ප්‍රමුඛ සංචාර නියෝජිතයින් අතරින් එක් අයෙක් වෙමු.",
  whyChooseUsReason6: "අපි අපගේ පාරිභෝගිකයින්ට අභිරුචිකරණය කරන ලද සහ විශේෂ සංචාර ලබා දෙමු.",
  whyChooseUsReason7: "අපි විශේෂ ගමනාන්ත සඳහා සංචාර සහ නිවාඩු පැකේජ ලබා දෙන ශ්‍රී ලංකාවේ ප්‍රමුඛ සංචාර නියෝජිතයෙක් වෙමු.",
  whyChooseUsReason8: "අපි අපගේ පාරිභෝගිකයින්ට 24/7 පාරිභෝගික සහාය ලබා දෙමු.",
  
  readMore: "තවත් කියවන්න",
  
  // How It Works
  howItWorksTitle: "එය කෙසේ ක්‍රියා කරයි?",
  
  // Common UI elements
  days: "දින",
  from: "සිට",
  perPerson: "පුද්ගලයෙකුට",
  
  step1Title: "1. දැන් විමසන්න",
  step1Time: "5 මිනිත්තු",
  step1FillingForm: "වෙබ් පෝරමය පුරවීම",
  step1WebChat: "වෙබ් සජීවී කතාබස්",
  step1Email: "විද්‍යුත් තැපෑල",
  step1Call: "අපට අමතන්න",
  
  step2Title: "2. සංචාර විශේෂඥයා සමඟ සම්බන්ධ වන්න",
  step2Time: "30 මිනිත්තු",
  step2Discuss: "ඔබගේ අවශ්‍යතා සාකච්ඡා කරන්න",
  step2FreeAdvice: "නොමිලේ විශේෂඥ සංචාර උපදෙස්",
  step2Support: "24/7 සහාය",
  
  step3Title: "3. සංචාර විකල්ප 3ක් ලැබීම",
  step3Discuss: "වෙනස්කම් සාකච්ඡා කරන්න",
  step3Finalise: "ගමන සැලසුම අවසන් කරන්න",
  step3Pay: "10% ගෙවන්න",
  
  step4Title: "4. ඔබගේ ගමන තහවුරු කිරීම ලබා ගන්න",
  step4FillingForm: "වෙබ් පෝරමය පුරවීම",
  step4Satisfaction: "100% සතුට සහතිකයි",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "සම්පූර්ණ ශ්‍රී ලංකා පරිපථය",
  completeSriLankaSubtitle: "සම්පූර්ණ",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "සම්පූර්ණ",
  completeSriLankaHighlights: "ආකර්ෂණ",
  completeSriLankaCulture: "සංස්කෘතිය",
  completeSriLankaHistory: "ඉතිහාසය",
  completeSriLankaNature: "ස්වභාවය",
  completeSriLankaBeach: "වෙරළ",
  completeSriLankaPrice: "පුද්ගලයෙකුට US $1850 සිට",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "සම්පූර්ණ ශ්‍රී ලංකා පරිපථය",
  completeSriLankaCircuitSubtitle: "සියලුම ප්‍රධාන ගමනාන්ත ආවරණය කරන සම්පූර්ණ ගමනක් සමඟ ශ්‍රී ලංකාවේ සම්පූර්ණ සුන්දරත්වය අත්දැකීම් කරන්න.",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "අනුරාධපුර",
  ancientCityStay: "අනුරාධපුරේ හෝටලය",
  ancientCityTransfer: "අනුරාධපුරට මාරුවීම",
  ancientCityExplore: "පුරාණ නටබුන් සහ ස්තූප ගවේෂණය කිරීම",
  ancientCityTemple: "ශ්‍රී මහා බෝධි ගස සංචාරය",
  ancientCityMuseum: "පුරාවිද්‍යා කෞතුකාගාරය සංචාරය",
  ancientCityLocation: "අනුරාධපුර පුරාණ නගරය",
  ancientCityDescription: "ශ්‍රී ලංකාවේ පුරාණ අගනුවර සහ යුනෙස්කෝ ලෝක උරුම අඩවිය සොයා බලන්න.",
  
  // Nuwara Eliya
  day5Title: "නුවරඑළිය",
  nuwaraEliyaTitle: "නුවරඑළිය",
  nuwaraEliyaStay: "නුවරඑළියේ හෝටලය",
  nuwaraEliyaTransfer: "නුවරඑළියට මාරුවීම",
  nuwaraEliyaTea: "තේ වතු සහ කර්මාන්තශාලා සංචාරය",
  nuwaraEliyaLake: "ග්‍රෙගරි වැව බෝට් ගමන",
  nuwaraEliyaExplore: "කුඩා එංගලන්තය ගවේෂණය කිරීම",
  nuwaraEliyaLocation: "නුවරඑළිය තේ රට",
  nuwaraEliyaDescription: "කුඩා එංගලන්තයේ සිසිල් කාලගුණය සහ තේ රටේ ආකර්ෂණ අත්දැකීම් කරන්න.",
  
  // Ella (Second Day)
  day6Title: "ඇල්ල",
  day7Title: "ඇල්ල දීර්ඝ",
  ellaWaterfall: "රාවණා ජලධරා සංචාරය",
  ellaTea: "තේ වතු සංචාරය",
  ellaRelax: "සන්සුන් වීම සහ කඳු දර්ශන භුක්ති විඳින්න",
  ellaLocal: "දේශීය ගම්මාන අත්දැකීම",
  ellaDay2Description: "ජලධරා සහ තේ රට ගවේෂණය කිරීම සඳහා ඇල්ලේ දෙවන දිනය.",
  
  // Mirissa
  day8Title: "මිරිස්ස",
  mirissaTitle: "මිරිස්ස",
  mirissaStay: "මිරිස්සේ වෙරළ ගස්ට්හවුස්",
  mirissaTransfer: "මිරිස්සට මාරුවීම",
  mirissaBeach: "මිරිස්ස වෙරළේ සන්සුන් වීම",
  mirissaWhale: "තල්මසුන් නැරඹීමේ සංචාරය (මූසම්)",
  mirissaRelax: "වෙරළ සන්සුන් වීම සහ සූර්යාස්තමය",
  mirissaLocation: "මිරිස්ස වෙරළ",
  mirissaDescription: "සුන්දර වෙරළවල් සහ තල්මසුන් නැරඹීමේ අවස්ථා භුක්ති විඳින්න.",
  
  // Mirissa (Second Day)
  day9Title: "මිරිස්ස දීර්ඝ",
  mirissaSnorkel: "ස්නෝකලිං සහ ජල ක්‍රීඩා",
  mirissaDiving: "ස්කූබා ඩයිවිං (විකල්ප)",
  mirissaSunset: "සූර්යාස්තමය වෙරළ ඇවිදීම",
  mirissaDay2Description: "ජල ක්‍රියාකාරකම් සහ වෙරළ සන්සුන් වීම සඳහා මිරිස්සේ දෙවන දිනය.",
  
  // Galle
  day10Title: "ගාල්ල",
  
  // Galle (Second Day)
  day11Title: "ගාල්ල දීර්ඝ",
  galleShopping: "ගාල්ල බලකොටුවේ සාප්පු ගැනීම",
  galleMuseum: "ගාල්ල සාගර කෞතුකාගාරය සංචාරය",
  galleBeach: "උණවටුනේ වෙරළ කාලය",
  galleDining: "බලකොටු අවන්හල්වල භෝජනය",
  galleDay2Description: "ඓතිහාසික බලකොටුවේ තවත් ගවේෂණය කිරීම සඳහා ගාල්ලේ දෙවන දිනය.",
  
  // Bentota
  day12Title: "බෙන්තොට",
  bentotaTitle: "බෙන්තොට",
  bentotaStay: "බෙන්තොටේ ගස්ට්හවුස්",
  bentotaTransfer: "බෙන්තොටට මාරුවීම",
  bentotaRiver: "බෙන්තොට ගඟ සෆාරි",
  bentotaBeach: "වෙරළ ක්‍රියාකාරකම්",
  bentotaSpa: "ස්පා සහ සුවපහසු ප්‍රතිකාර",
  bentotaLocation: "බෙන්තොට වෙරළ ගස්ට්හවුස්",
  bentotaDescription: "ගඟ ක්‍රියාකාරකම් සහිත සුන්දර වෙරළ ගස්ට්හවුස්වල සන්සුන් වන්න.",
  
  // Colombo
  day13Title: "කොළඹ",
  colomboTitle: "කොළඹ",
  colomboStay: "කොළඹේ හෝටලය",
  colomboTransfer: "කොළඹට මාරුවීම",
  colomboFort: "කොළඹ බලකොටුව ගවේෂණය කිරීම",
  colomboTemple: "ගංගාරාමය දේවස්ථානය සංචාරය",
  colomboShopping: "ඔඩෙල් සහ බෙයාෆුට් හි සාප්පු ගැනීම",
  colomboLocation: "කොළඹ නගරය",
  colomboDescription: "අගනුවරේ ආකර්ෂණ සහ සාප්පු ගැනීම ගවේෂණය කරන්න.",
  
  // Departure
  day14Title: "පිටත්වීම",
  departureTitle: "පිටත්වීම",
  departureStay: "ගුවන්තොටුපළ හෝටලය හෝ පිටත්වීම",
  departureBreakfast: "අවසාන උදෑසන ආහාරය",
  departureShopping: "අවසාන මොහොතේ සාප්පු ගැනීම",
  departureTransfer: "ගුවන්තොටුපළට මාරුවීම",
  departureAirport: "බණ්ඩාරනායක ජාත්‍යන්තර ගුවන්තොටුපළෙන් පිටත්වීම",
  departureLocation: "බණ්ඩාරනායක ජාත්‍යන්තර ගුවන්තොටුපළ",
  departureDescription: "ගුවන්තොටුපළ මාරුවීම සහ පිටත්වීම සමඟ අවසාන දිනය.",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "වනජීවී සහ සංස්කෘතික උරුම සංචාරය",
  wildlifeCulturalCircuitSubtitle: "මෙම සම්පූර්ණ ගමනේදී ශ්‍රී ලංකාවේ වනජීවී, පුරාණ නගර සහ සංස්කෘතික උරුම අත්දැකීම් කරන්න.",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "උඩවලාවේ",
  udawalaweStay: "උඩවලාවේ සෆාරි ලොජ්",
  udawalaweTransfer: "උඩවලාවේට මාරුවීම",
  udawalaweSafari: "උඩවලාවේ ජාතික උද්‍යාන සෆාරි",
  udawalaweElephants: "ඇතුන් නැරඹීම සහ ඡායාරූප",
  udawalaweBirds: "පක්ෂීන් නැරඹීමේ සංචාරය",
  udawalaweLocation: "උඩවලාවේ ජාතික උද්‍යාන",
  udawalaweDescription: "ඔවුන්ගේ ස්වභාවික වාසස්ථානවල ඇතුන්, පක්ෂීන් සහ වෙනත් සතුන් සමඟ ශ්‍රී ලංකාවේ වනජීවී අත්දැකීම් කරන්න.",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "ඇල්ල",
  ellaWildlifeStay: "ඇල්ලේ හෝටලය",
  ellaWildlifeTransfer: "ඇල්ලට මාරුවීම",
  ellaWildlifeTrain: "ඇල්ලට සුන්දර දුම්රිය ගමන",
  ellaWildlifePeak: "කුඩා ආදම් කන්ද ගවේෂණය",
  ellaWildlifeBridge: "නව ආර්ච් බොඩිය දර්ශන ලක්ෂ්‍යය",
  ellaWildlifeLocation: "ඇල්ල කඳු ස්ථානය",
  ellaWildlifeDescription: "අපූරු කඳු දර්ශන සහ තේ වතු සමඟ සුන්දර කඳු රට ගවේෂණය කරන්න.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "නුවරඑළිය",
  nuwaraEliyaWildlifeStay: "නුවරඑළියේ හෝටලය",
  nuwaraEliyaWildlifeTransfer: "නුවරඑළියට මාරුවීම",
  nuwaraEliyaWildlifeTea: "තේ වතු සහ කර්මාන්තශාලා සංචාරය",
  nuwaraEliyaWildlifeLake: "ග්‍රෙගරි වැව බෝට් ගමන",
  nuwaraEliyaWildlifeExplore: "කුඩා එංගලන්තය ගවේෂණය කිරීම",
  nuwaraEliyaWildlifeLocation: "නුවරඑළිය තේ රට",
  nuwaraEliyaWildlifeDescription: "කුඩා එංගලන්තයේ සිසිල් කාලගුණය සහ තේ රටේ ආකර්ෂණ අත්දැකීම් කරන්න.",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "මහනුවර",
  kandyWildlifeStay: "මහනුවරේ හෝටලය",
  kandyWildlifeTransfer: "මහනුවරට මාරුවීම",
  kandyWildlifeTemple: "ශ්‍රී දළදා මාළිගාව",
  kandyWildlifeGardens: "රාජකීය උද්‍යාන, පේරාදෙණිය",
  kandyWildlifeLake: "මහනුවර වැව ඇවිදීම",
  kandyWildlifeLocation: "ශ්‍රී දළදා මාළිගාව",
  kandyWildlifeDescription: "පූජනීය උරුමය සහ සිරිත් උද්‍යාන සහිත සංස්කෘතික අගනුවර.",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "සීගිරිය",
  sigiriyaWildlifeStay: "සීගිරියේ හෝටලය",
  sigiriyaWildlifeTransfer: "සීගිරියට මාරුවීම",
  sigiriyaWildlifeClimb: "සීගිරිය ගල් බලකොටුවට නැගීම",
  sigiriyaWildlifeExplore: "ජල උද්‍යාන සහ චිත්‍ර ගවේෂණය කිරීම",
  sigiriyaWildlifeVillage: "ගම්මාන අත්දැකීම හෝ බයිසිකල් ගමන (විකල්ප)",
  sigiriyaWildlifeLocation: "සීගිරිය ගල් බලකොටුව",
  sigiriyaWildlifeDescription: "විසිතරාකාර දර්ශන සහිත අයිකොනික් යුනෙස්කෝ ලෝක උරුම අඩවිය.",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "අනුරාධපුර",
  anuradhapuraWildlifeStay: "අනුරාධපුරේ හෝටලය",
  anuradhapuraWildlifeTransfer: "අනුරාධපුරට මාරුවීම",
  anuradhapuraWildlifeExplore: "පුරාණ නටබුන් සහ ස්තූප ගවේෂණය කිරීම",
  anuradhapuraWildlifeTemple: "ශ්‍රී මහා බෝධි ගස සංචාරය",
  anuradhapuraWildlifeMuseum: "පුරාවිද්‍යා කෞතුකාගාරය සංචාරය",
  anuradhapuraWildlifeLocation: "අනුරාධපුර පුරාණ නගරය",
  anuradhapuraWildlifeDescription: "ශ්‍රී ලංකාවේ පුරාණ අගනුවර සහ යුනෙස්කෝ ලෝක උරුම අඩවිය සොයා බලන්න.",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "පොලොන්නරුව",
  polonnaruwaStay: "පොලොන්නරුවේ හෝටලය",
  polonnaruwaTransfer: "පොලොන්නරුවට මාරුවීම",
  polonnaruwaExplore: "පුරාණ නටබුන් ගවේෂණය කිරීම",
  polonnaruwaGalVihara: "ගල් විහාර සංචාරය",
  polonnaruwaMuseum: "පොලොන්නරුව කෞතුකාගාරය සංචාරය",
  polonnaruwaLocation: "පොලොන්නරුව පුරාණ නගරය",
  polonnaruwaDescription: "හොඳින් සංරක්ෂණය කරන ලද නටබුන් සහ මූර්ති සමඟ පුරාණ අගනුවර ගවේෂණය කරන්න.",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "ත්‍රිකුණාමලය",
  trincomaleeStay: "ත්‍රිකුණාමලයේ හෝටලය",
  trincomaleeTransfer: "ත්‍රිකුණාමලයට මාරුවීම",
  trincomaleeBeach: "නිලාවෙලි වෙරළේ සන්සුන් වීම",
  trincomaleeWhale: "තල්මසුන් නැරඹීමේ සංචාරය (මූසම්)",
  trincomaleeFort: "ෆ්‍රෙඩ්රික් බලකොටුව ගවේෂණය කිරීම",
  trincomaleeLocation: "නිලාවෙලි වෙරළ, ත්‍රිකුණාමලය",
  trincomaleeDescription: "සුන්දර වෙරළවල් සහ තල්මසුන් නැරඹීමේ අවස්ථා භුක්ති විඳින්න.",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "කොළඹ",
  colomboWildlifeStay: "කොළඹේ හෝටලය",
  colomboWildlifeTransfer: "කොළඹට මාරුවීම",
  colomboWildlifeFort: "කොළඹ බලකොටුව ගවේෂණය කිරීම",
  colomboWildlifeTemple: "ගංගාරාමය දේවස්ථානය සංචාරය",
  colomboWildlifeShopping: "ඔඩෙල් සහ බෙයාෆුට් හි සාප්පු ගැනීම",
  colomboWildlifeLocation: "කොළඹ නගරය",
  colomboWildlifeDescription: "අගනුවරේ ආකර්ෂණ සහ සාප්පු ගැනීම ගවේෂණය කරන්න.",
  
  // Wildlife Cultural Tour
  wildlifeCulturalTitle: "වනජීවී සහ සංස්කෘතික උරුම සංචාරය",
  wildlifeCulturalType: "වනජීවී සහ සංස්කෘතිය",
  wildlifeCulturalHighlights: "ආකර්ෂණ",
  wildlifeCulturalWildlife: "වනජීවී",
  wildlifeCulturalCulture: "සංස්කෘතිය",
  wildlifeCulturalHistory: "ඉතිහාසය",
  wildlifeCulturalNature: "ස්වභාවය",
  
  // Hill Country Beach Tour
  hillCountryBeachTitle: "උඩරට සහ වෙරළ සංචාරය",
  hillCountryBeachType: "උඩරට සහ වෙරළ",
  hillCountryBeachHighlights: "ආකර්ෂණ",
  hillCountryBeachNature: "ස්වභාවය",
  hillCountryBeachBeach: "වෙරළ",
  hillCountryBeachCulture: "සංස්කෘතිය",
  hillCountryBeachAdventure: "වික්‍රමාන්ත",
  
  // Cultural Triangle Beach Tour
  culturalTriangleBeachTitle: "සංස්කෘතික ත්‍රිකෝණය සහ වෙරළ සංචාරය",
  culturalTriangleBeachType: "සංස්කෘතික ත්‍රිකෝණය සහ වෙරළ",
  culturalTriangleBeachHighlights: "ආකර්ෂණ",
  culturalTriangleBeachCulture: "සංස්කෘතිය",
  culturalTriangleBeachHistory: "ඉතිහාසය",
  culturalTriangleBeachBeach: "වෙරළ",
  culturalTriangleBeachRelaxation: "සන්සුන් වීම",
  
  // Package 1
  package1Title: "පැකේජ 1 - ශ්‍රී ලංකාව",
  package1Duration: "රාත්‍රි 4ක් දින 5ක්",
  package1Charges: "හෝටලයේ සහ ප්‍රවාහන ගාස්තු පමණක්",
  package1Hotel: "ස්ටාර් 4 හෝටලයකට නින්ද, රාත්‍රි ආහාර සහ උදෑසන ආහාර ඇතුළත්",
  package1Price: "Starting From: USD 780\nper 2 persons",
  package1Day1: "දින 1",
  package1Day1Activity1: "පින්නවල",
  package1Day1Activity2: "මහනුවර (මහනුවර නැටුම)",
  package1Day2: "දින 2",
  package1Day2Activity1: "නෙල්ලිගල",
  package1Day2Activity2: "මහනුවර දේවස්ථානය",
  package1Day3: "දින 3",
  package1Day3Activity1: "ගඩලාදෙණිය, අඹක්කේ",
  package1Day3Activity2: "පේරාදෙණිය උද්‍යානය",
  package1Day4: "දින 4",
  package1Day4Activity1: "කෞතුකාගාරය මහනුවර",
  package1Day4Activity2: "රත්න, මසාල සහ බතික් සාප්පු ගැනීම",
  package1Activities: "ක්‍රියාකාරකම්",
  
  // Package 2
  package2Title: "පැකේජ 2 - ශ්‍රී ලංකාව",
  package2Duration: "රාත්‍රි 4ක් දින 5ක්",
  package2Charges: "හෝටලයේ සහ ප්‍රවාහන ගාස්තු පමණක්",
  package2Hotel: "ස්ටාර් 4 හෝටලයකට නින්ද, රාත්‍රි ආහාර සහ උදෑසන ආහාර ඇතුළත්",
  package2Price: "Starting From: USD 1130\nper 2 persons",
  package2Day1: "දින 1",
  package2Day1Activity1: "පින්නවල",
  package2Day1Activity2: "මහනුවර දේවස්ථානය",
  package2Day1Activity3: "මහනුවර නැටුම",
  package2Day2: "දින 2",
  package2Day2Activity1: "රත්න, මසාල සහ බතික් සාප්පු ගැනීම",
  package2Day2Activity2: "පේරාදෙණිය උද්‍යානය",
  package2Day2Activity3: "නෙල්ලිගල",
  package2Day3: "දින 3",
  package2Day3Activity1: "නුවරඑළිය",
  package2Day3Activity2: "ග්‍රෙගරි වැව",
  package2Day4: "දින 4",
  package2Day4Activity1: "අබේවෙල කුරුළුපැටවුන්ගේ ගොවිපල",
  package2Activities: "ක්‍රියාකාරකම්",
  
  // Package 3
  package3Title: "පැකේජ 3 - ශ්‍රී ලංකාව",
  package3Duration: "රාත්‍රි 4ක් දින 5ක්",
  package3Charges: "හෝටලයේ සහ ප්‍රවාහන ගාස්තු පමණක්",
  package3Hotel: "ස්ටාර් 4 හෝටලයකට නින්ද, රාත්‍රි ආහාර සහ උදෑසන ආහාර ඇතුළත්",
  package3Price: "Starting From: USD 895\nper 2 persons",
  package3Day1: "දින 1",
  package3Day1Activity1: "පින්නවල",
  package3Day1Activity2: "මහනුවර දේවස්ථානය",
  package3Day1Activity3: "මහනුවර නැටුම",
  package3Day2: "දින 2",
  package3Day2Activity1: "පේරාදෙණිය උද්‍යානය",
  package3Day2Activity2: "නෙල්ලිගල",
  package3Day2Activity3: "රත්න, මසාල සහ බතික් සාප්පු ගැනීම",
  package3Day3: "දින 3",
  package3Day3Activity1: "සීගිරිය",
  package3Day4: "දින 4",
  package3Day4Activity1: "දඹුල්ල දේවස්ථානය",
  package3Day4Activity2: "දඹුල්ල ගම්මාන දේවස්ථානය",
  package3Activities: "ක්‍රියාකාරකම්",
  
  
  // Package tags
  hotel: "හෝටලය",
  transport: "ප්‍රවාහනය",
  cultural: "සංස්කෘතික",
  shopping: "සාප්පු ගැනීම",
  hillCountry: "කඳුකර ප්‍රදේශය",
  teaPlantations: "තේ වතු",
  sigiriya: "සීගිරිය",
  kandy: "මහනුවර",
  ella: "ඇල්ල",
  mirissa: "මිරිස්ස",
  yala: "යාල",
  galle: "ගාල්ල",
  colombo: "කොළඹ",
  bentota: "බෙන්තොට",
  kitulgala: "කිතුල්ගල",
  arugamBay: "ආරුගම්බේ",
  beach: "වෙරළ",
  adventure: "වික්‍රමාන්විත",
  heritageSites: "උරුම ස්ථාන",
  safari: "සෆාරි",
  wildlife: "වන සතුන්",
  
  // Package titles (short version for cards)
  package1: "පැකේජ 1",
  package2: "පැකේජ 2",
  package3: "පැකේජ 3",

  // Package 4
  package4Title: "Package 4 (Couples) - Sri Lanka",
  package4Duration: "5 nights 6 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Starting From: USD 990\nper 2 persons",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Package 4 (Couples)",

  // Package 5
  package5Title: "Package 5 - Sri Lanka",
  package5Duration: "6 nights 7 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Starting From: USD 1390\nper 2 persons",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Package 5",

};
